<script>
import saveIcon from '@assets/images/mind-map-overlay/save.svg'

export default {
  props: ['bot_uuid', 'title', 'owner_id', 'user_id'],
  
  computed: {
    skill_item(){
        return this.$store.getters['skills/GET_SKILLS_ITEM'];
    },
    session_user_item(){
        let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        return session.user ? session.user : null;
    },
  },

  methods:{
    emitSave() {
      this.$emit('save')
    },
    emitTesting() {
      this.$emit('testing')
    },
    emitEdit() {
      this.$emit('edite')
    },
    emitChannels() {
      this.$emit('showChannels')
    },
    emitLoadSkill() {
      this.$emit('showLoadSkill')
    },
    emitSaveBlocks() {
      this.$emit('showSaveBlocks')
    }
  }
}
</script>

<template>
  <div class="wrapper">
    <div class="left-group" style="margin-left: 90px">
      <a @click="$router.go(-1)">
        <i class="uil uil-angle-left" />Назад
      </a>
      <h5> {{ title }} </h5>
      <a v-if="session_user_item && (user_id === session_user_item.id || owner_id === session_user_item.id || session_user_item.role === 'administrator')" id="settings-btn" class="icon-btn" style="cursor: pointer; margin-left: 15px" @click="emitEdit">
        <b-tooltip :target="'settings-btn'" placement="top">Редактировать</b-tooltip>
        <i style="color:rgb(116 112 112); line-height:0; margin:0px; margin-top: 3px; padding:0px;" class="uil uil-cog" />
      </a>
      <a v-if="session_user_item.role === 'administrator'" id="bot-channels-btn" class="icon-btn" style="cursor: pointer; margin-left: 7px" @click="emitChannels">
        <b-tooltip :target="'bot-channels-btn'" placement="top">Каналы коммуникаций</b-tooltip>
        <i style="color:rgb(116 112 112); line-height:0; margin:0px; margin-left: 5px; margin-top: -3px; padding:0px; font-size: 18px" class="uil uil-rss-alt" />
      </a>
    </div>
    <div class="right-group">
      <button v-if="session_user_item && (user_id === session_user_item.id || owner_id === session_user_item.id || session_user_item.role === 'administrator')" type="submit" id="save-btn" class="icon-btn" @click="emitSave">
        <b-tooltip :target="'save-btn'" placement="top">Сохранить</b-tooltip>
        <img :src="require('@assets/images/mind-map-overlay/save.svg')" style="color:rgb(116 112 112)" alt="">
      </button>
      <button v-if="session_user_item && (user_id === session_user_item.id || owner_id === session_user_item.id || session_user_item.role === 'administrator')" type="submit" id="import-btn" class="icon-btn" @click="emitLoadSkill">
        <b-tooltip :target="'import-btn'" placement="top">Загрузить сценарий</b-tooltip>
        <i style="color:rgb(116 112 112); line-height:0; margin:0px; margin-top: 3px; padding:0px;" class="uil uil-file-download" />
      </button>
      <button type="submit" id="export-btn" class="icon-btn" style="margin-right: 10px" @click="emitSaveBlocks">
        <b-tooltip :target="'export-btn'" placement="top">Выгрузить сценарий</b-tooltip>
        <i style="color:rgb(116 112 112); line-height:0; margin:0px; margin-top: 3px; padding:0px;" class="uil uil-file-upload" />
      </button>
      <button v-if="bot_uuid !== null" type="button" class="btn btn-primary" @click="emitTesting">
        <i class="uil uil-play " /> Протестировать
      </button>
    </div>
  </div>
</template>

<style scoped>
.left-group, .right-group, .wrapper {
  display: flex;
  align-items: center;
}

.wrapper {
  position: absolute;
  justify-content: space-between;
  width: calc(100vw - 250px);
  padding: 20px;
  z-index: 10;
  top: 0;
}

.left-group {
  gap: 6px;
}

.left-group a:first-child {
  margin-right: 10px;
  cursor: pointer;
}

.right-group{
  gap: 12px;
}

.icon-btn {
  width: 39px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: white;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.06);
  border: none;
}

.icon-btn:hover {
  background: #f4f4f4;
}

</style>